import React, { Component, PropTypes } from 'react';

let $ = window.jQuery;

export default class PhoneField extends Component {
    static propTypes = {
        val: PropTypes.string,
        phoneType: PropTypes.number,
        id: PropTypes.string.isRequired,
        typeId: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        help: PropTypes.string.isRequired
    };

    state = {
        val : '',
        phoneType : ''
    };

    componentDidMount() {
        let mask = '(9999) 999-9999'; //default mask
        // eslint-disable-next-line
        if(this.props.phoneType != undefined && this.props.phoneType != '') {
            if (parseInt(this.props.phoneType, 10) === 1) { //mobile
                mask = '(9999) 999-9999';
            } else {
                mask = '999-9999';
            }
        }
        $('#'+this.props.id).inputmask("text", {
            mask: mask,
            autoUnmask: true,
            showMaskOnHover: false,
            oncomplete : (e) => {
                this.setState({
                    val : e.target.value,
                }, () => {
                    let phoneNumber = this.state.val;

                    this.props.updatePhone(phoneNumber, this.state.phoneType);
                });
            }
        })

        this.setState({
            val: this.props.val,
            phoneType: this.props.phoneType
        });
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            val: nextProps.val,
            phoneType: nextProps.phoneType
        });
    }

    shouldComponentUpdate(nextProps, nextState) {
        return true;
    }

    handlePhoneTypeChange = (e) => {
        this.setState({
            phoneType: parseInt(e.target.value, 10)
        }, () => {
            let phoneType = this.state.phoneType;

            this.props.updatePhone(this.state.val, phoneType);
        });

        let mask = '(9999) 999-9999'; //default mask
        if (parseInt(e.target.value, 10) === 1) { //mobile
            mask = '(9999) 999-9999';
        } else {
            mask = '999-9999';
        }
        $('#'+this.props.id).inputmask("text", {
            mask: mask,
            autoUnmask: true,
            showMaskOnHover: false,
            oncomplete : (e) => {
                this.setState({
                    val : e.target.value,
                }, ()=> {
                    let phoneNumber = this.state.val;
                    this.props.updatePhone(phoneNumber, this.state.phoneType);
                });
            }
        })
    }

    render() {
        var className = this.state.val ? 'form-control edited' : 'form-control';

        return (
            <div className="form-group form-md-line-input">
                <div className="input-group" style={{ width : '100%' }}>
                    <div className="input-group-control">
                        <input type="text" className={className}
                               id={this.props.id}
                               name={this.props.id}
                               value={this.state.val} />
                        <label htmlFor={this.props.id}>{this.props.label}</label>
                    </div>
                    &nbsp;
                    <div className="input-group-control">
                        <select name={this.props.typeId} className="form-control" value={this.props.phoneType}
                                onChange={this.handlePhoneTypeChange} >
                            <option value="1">Mobile</option>
                            <option value="2">Home</option>
                            <option value="3">Work</option>
                            <option value="4">Fax</option>
                        </select>
                        <label className="control-label">&nbsp;</label>
                    </div>
                </div>
            </div>
        )
    }
}


/** WEBPACK FOOTER **
 ** ./src/commons/Inputs/PhoneField.js
 **/